import { useEffect } from 'react';

import { showErrorToast } from 'shared/components/Toast/Toast';

type ShowErrorToastProps = {
  isError: boolean;
  message: string;
};

export const useShowErrorToast = ({
  isError,
  message,
}: ShowErrorToastProps) => {
  useEffect(() => {
    if (isError) {
      showErrorToast(message);
    }
  }, [isError, message]);
};
